export default function quoteCreateTemplate(data){

    this.popup("quoteCreateTemplate", {
      params: {id: data.id, name: data.name, prefix: data.prefix}, 
      header : this.translate("LBL_QUOTE_CREATE_TEMPLATE", "Quotes")
  });
  
  }